<template>
  <div style="display: inline-block">
    <Button type="primary" @click="Modal1 = true" :size="buttonSize"
      >{{$t('HSInspectManageMat.t59')}}</Button
    >
    <Modal
      :title="$t('HSInspectManageMat.t60')"
      :width="400"
      v-model="Modal1"
      @on-cancel="setTableCancel"
      @on-ok="setTableSave"
      :loading="loading"
    >
      <Button type="primary" @click="setTableDefault">{{$t('HSInspectManageMat.t50')}}</Button>
      <Button type="primary" style="margin-left:10px;" @click="setTableCancel">{{$t('HSInspectManageMat.t51')}}</Button>
      <ul class="setTable setTable2 mt10">
        <li class="trItem">
          <div class="tdItem tdItem1"><b>{{$t('HSInspectManageMat.t52')}}</b></div>
          <div class="tdItem tdItem2"><b>{{$t('HSInspectManageMat.t53')}}</b></div>
          <div class="tdItem tdItem3"><b>{{$t('HSInspectManageMat.t54')}}</b></div>
        </li>
      </ul>
      <div>
        <div class="setTable">
          <transition-group name="flip-list">
            <div
              v-for="(item, index) in setTableDataFilter"
              :key="item.key"
              :liKey="item.key"
              draggable="true"
              @dragstart="dragstart(item)"
              @dragenter="dragenter(item)"
              class="trItem"
            >
              <div class="tdItem tdItem1">
                <Checkbox
                  v-model="item.checked"
                  @on-change="checkboxChange($event, index)"
                ></Checkbox>
              </div>
              <div class="tdItem tdItem2">
                {{ item.title || item.title2 }}
              </div>
              <div class="tdItem tdItem3">
                <!-- <span class="cur" @click="changeLocation('up', index)">
                                    <Icon type="ios-arrow-up"
                                        :size="18" 
                                        ></Icon>
                                </span>
                                <span class="ml20 inBlock cur" @click="changeLocation('dowm', index)">
                                    <Icon type="ios-arrow-down"
                                        :size="18"
                                        ></Icon>
                                </span> -->
                <span
                  class="tdButton mr20"
                  @click="changeLocation('top', index)"
                  >{{$t('HSInspectManageMat.t55')}}</span
                >
                <span
                  class="tdButton mr20"
                  @click="changeLocation('bottom', index)"
                  >{{$t('HSInspectManageMat.t56')}}</span
                >
              </div>
            </div>
          </transition-group>
        </div>
      </div>
      <div slot="footer">
            <Button type="default" @click="claseModal">{{ $t('common.cancelBtn') }}</Button>
            <Button type="primary" @click="setTableSave(false)" :loading="loading">{{ $t('common.confirmBtn') }}</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
export default {
    computed: {
        /* 过滤不需要显示的字段 */
        setTableDataFilter() {
            return this.setTableData.filter((item) => !this.filterColumns.includes(item.title));
        },
    },
  data() {
    return {
      tableTimer: null,
      defaultColumns: [], // 最原始的列数组
      oldNum: 0,
      newNum: 0,
      draging: null, // 被拖拽的对象
      target: null, // 目标对象
      loading: false,
      isFirst: true,
      setTableData: [],
      setTableDataTemp: [], // 临时保存数组
      selectionColumns: [], // 勾选
      setColumns: [
        {
          title: this.$t('HSInspectManageMat.t57'), // "显示",
          render: (h, params) => {
            return h("Checkbox", {
              props: {
                value: params.row.checked,
              },
              on: {
                "on-change": (val) => {
                  this.$set(this.setTableData[params.index], "checked", val);
                },
              },
            });
          },
          width: 60,
        },
        {
          title: this.$t('HSInspectManageMat.t53'), // "列名",
          key: "title",
          width: 200,
        },
        {
          title: this.$t('HSInspectManageMat.t58'), // "调整顺序",
          align: "center",
          render: (h, params) => {
            return h("div", {}, [
              h(
                "span",
                {
                  on: {
                    click: () => {
                      this.changeLocation("up", params.index);
                    },
                  },
                },
                [
                  h("Icon", {
                    props: {
                      type: "ios-arrow-up",
                      size: 18,
                    },
                    style: {
                      marginLeft: "20px",
                      cursor: "pointer",
                    },
                  }),
                ]
              ),
              h(
                "span",
                {
                  on: {
                    click: () => {
                      this.changeLocation("down", params.index);
                    },
                  },
                },
                [
                  h("Icon", {
                    props: {
                      type: "ios-arrow-down",
                      size: 18,
                    },
                    style: {
                      marginLeft: "20px",
                      cursor: "pointer",
                    },
                  }),
                ]
              ),
              h(
                "span",
                {
                  style: {
                    display: "inline-block",
                    marginLeft: "20px",
                    cursor: "pointer",
                  },
                  on: {
                    click: () => {
                      this.changeLocation("top", params.index);
                    },
                  },
                },
                this.$t('HSInspectManageMat.t55'), // "置顶"
              ),
              h(
                "span",
                {
                  style: {
                    display: "inline-block",
                    marginLeft: "20px",
                    cursor: "pointer",
                  },
                  on: {
                    click: () => {
                      this.changeLocation("bottom", params.index);
                    },
                  },
                },
                this.$t('HSInspectManageMat.t56'), // "至尾"
              ),
            ]);
          },
        },
      ],
      Modal1: false,
    };
  },
  props: {
    columns: {},
    buttonSize: {
      default: "default",
    },
    columnsKey: {
      default: "setTableColumns",
    },
    handOperation: {
      default: false,
    },
    filterColumns: {
      default: () => [],
    },
    /* 唯一字段 */
    uniqueKey: {
        type: String,
        default: () => '',
    },
  },
  methods: {
    checkboxChange(val, index) {
      this.$set(this.setTableData[index], "checked", val);
    },
    // 数组元素移动
    changeLocation(type, index) {
      let array = this.setTableData;
      if (type === "up") {
        if (index !== 0) {
          array[index] = array.splice(index - 1, 1, array[index])[0];
        }
      } else if (type === "down") {
        if (index !== array.length - 1) {
          array[index] = array.splice(index + 1, 1, array[index])[0];
        }
      } else if (type === "top") {
        array.unshift(array.splice(index, 1)[0]);
      } else if (type === "bottom") {
        array.push(array.splice(index, 1)[0]);
      }
    },
    // 恢复到系统默认
    setTableDefault() {
      let keys = [];
      let arr = this.objDeepCopy(this.defaultColumns).filter(
        (item) => item.type !== "selection"
      );
      arr.map((item, index) => {
        keys.push(item.key);
        arr[index].checked = true;
      });
      this.setTableData.map((item, index) => {
        if (!keys.includes(item.key)) {
          arr.splice(index, 0, {
            ...item,
            checked: true,
          });
        }
      });
      this.setTableData = arr;
    },
    claseModal() {
        this.Modal1 = false;
        this.setTableCancel();
    },
    // 取消修改
    setTableCancel() {
      // 还原
      this.setTableData = this.objDeepCopy(this.setTableDataTemp);
    },
    /** 深拷贝 */
    objDeepCopy: function (source) {
      var sourceCopy = source instanceof Array ? [] : {};
      for (var item in source) {
        if (typeof source[item] === "object") {
          if (source[item] === null) {
            sourceCopy[item] = null;
          } else {
            sourceCopy[item] = this.objDeepCopy(source[item]);
          }
        } else {
          sourceCopy[item] = source[item];
        }
      }
      return sourceCopy;
    },
    // 保存
    setTableSave(isAuto) {
      this.loading = true;
      // 如果是主动点确定按钮的，则把数据保存到localStorage
      if (this.setTableData.length > 0 && !isAuto) {
        localStorage.setItem(
            `${location.href}${
              JSON.parse(localStorage.getItem("supplierInfo")).vendorCode
            }${
              this.columnsKey === "setTableColumns" ? "" : this.columnsKey
            }${this.uniqueKey}tableColumnsLocal`,
            JSON.stringify(this.setTableData)
          );
      }
      let arr = [];
      // 过滤未被勾选显示的列
      arr = this.setTableData.filter((item) => item.checked);
      this.$emit("setTableUpdate", this.selectionColumns.concat(arr));
      setTimeout(() => {
        this.loading = false;
        this.Modal1 = false;
      }, 3000);
    },
    // 记录初始信息
    dragstart(value) {
      this.oldNum = value;
    },
    // 做最终操作
    dragend(value) {
      if (this.oldNum !== this.newNum) {
        let oldIndex = this.setTableData.indexOf(this.oldNum);
        let newIndex = this.setTableData.indexOf(this.newNum);
        let newItems = [...this.setTableData];
        // 删除老的节点
        newItems.splice(oldIndex, 1);
        // 在列表中目标位置增加新的节点
        newItems.splice(newIndex, 0, this.oldNum);
        // this.items一改变，transition-group就起了作用
        this.setTableData = [...newItems];
      }
      setTimeout(() => {
        this.tableTimer = null;
      }, 100);
    },
    // 记录移动过程中信息
    dragenter(value) {
      this.newNum = value;
      if (!this.tableTimer) {
        this.dragend(value);
        this.tableTimer = 1;
      }
    },
    validIsMf() {
      let isMf =
        window.environment.isPro
          ? window.location.pathname === "/gn/meifu.html"
          : window.location.pathname === "/meifu.html";
      return isMf;
    },
    // 监听columns的变化
    watchColumns(newVal, reloadLocal) {
      // reloadLocal 是否读取localStorage内的数据
      let newArray = [];
      let columnsLocal = "";
      if (reloadLocal) {
            columnsLocal = localStorage.getItem(
                `${location.href}${
                JSON.parse(localStorage.getItem("supplierInfo")).vendorCode
                }${
                this.columnsKey === "setTableColumns" ? "" : this.columnsKey
                }${this.uniqueKey}tableColumnsLocal`
            );
        // 过滤通过快码来判断是否显示的字段
        if (typeof JSON.parse(columnsLocal) === "object" && columnsLocal) {
          columnsLocal = JSON.stringify(
            JSON.parse(columnsLocal).filter(
              (item) => !this.filterColumns.includes(item.title)
            )
          );
        }
      }
      newVal.map((item) => {
        if (item.key) {
          if (item.hasOwnProperty("checked")) {
            newArray.push(item);
          } else {
            newArray.push({
              ...item,
              checked: true,
            });
          }
        } else {
          if (item.type === "selection") {
            this.selectionColumns = [item];
          }
        }
      });
      // 本地缓存是否有数据
      if (!columnsLocal) {
        this.setTableData = this.objDeepCopy(newArray);
      } else {
        if (JSON.parse(columnsLocal).length > 0) {
          let arr = JSON.parse(columnsLocal);
          try {
            arr.map((item, index) => {
              try {
                let obj = newArray.find((item2) => item2.key === item.key);
                if (obj) {
                  arr[index] = {
                    ...obj,
                    checked: item.checked,
                  };
                }
              } catch (err) {
                console.log(err);
              }
            });
          } catch (err) {
            console.log(err);
          }
          this.setTableData = arr;
        }
      }
      // console.log(this.setTableData);
      this.setTableSave(true);
      // // 防止死循环
      // if (this.isFirst) {
      //     // this.defaultColumns = this.objDeepCopy(newVal);
      //     this.setTableSave(true);
      //     this.isFirst = false;
      // }
    },
  },
  watch: {
    Modal1(val) {
      if (val) {
        // 临时备份数据，取消的时候可还原
        // this.setTableDataTemp = this.objDeepCopy(this.setTableData);
        // this.setTableData = this.columns;
        // let newArray = [];
        // let keys = [];
        // console.log('this.setTableData', JSON.stringify(this.setTableData));
        // this.setTableData.map((item) => {
        //     keys.push(item.key);
        // });
        // console.log('this.defaultColumns', JSON.stringify(this.defaultColumns));
        let newArray = [];
        let keys = [];
        let keys2 = [];
        let keys3 = [];
        // console.log('this.columns', JSON.stringify(this.columns));
        this.columns.map((item) => {
          keys2.push(item.key);
        });
        // console.log('this.defaultColumns.concat(this.columns)', JSON.stringify(this.defaultColumns.concat(this.columns)));
        this.columns.concat(this.defaultColumns).map((item, index) => {
          if (
            item.key &&
            !keys.includes(item.key) &&
            !keys3.includes(item.title)
          ) {
            newArray.push({
              ...item,
              checked: keys2.includes(item.key),
            });
            keys.push(item.key);
            keys3.push(item.title);
          }
        });
        this.setTableData = newArray;
        // console.log('this.setTableData', JSON.stringify(this.setTableData));
        this.setTableDataTemp = this.objDeepCopy(this.setTableData);
        // this.watchColumns(this.objDeepCopy(this.columns), false);
      }
    },
    // columns: {
    //     handler (val) {
    //         console.log('columns', JSON.stringify(val));
    //     },
    //     deep: true
    // }
  },
  mounted() {
    this.watchColumns(this.columns, true);
    // 备份最原始的顺序
    this.defaultColumns = this.objDeepCopy(this.columns);
  },
};
</script>
<style lang="less" scoped>
.flip-list-move {
  transition: all 0.1s linear;
}
.setTable2 {
  border-bottom: none;
  background: #88c1f4;
}
.setTable {
  border: 1px solid #ccc;
  border-top: none;
  .trItem {
    padding: 5px 0;
    border-bottom: 1px solid #e9eaec;
  }
  .tdItem {
    display: inline-block;
  }
  .tdItem1 {
    width: 70px;
    text-align: center;
  }
  .tdItem2 {
    width: 188px;
  }
  .tdItem3 {
    width: 100px;
  }
  .tdButton {
    display: inline-block;
    cursor: pointer;
  }
}
.mt10 {
  margin-top: 10px;
}
.mr20 {
  margin-right: 20px;
}
.cur {
  cursor: pointer;
}
.inBlock {
  display: inline-block;
}
</style>